const videoTours = [
  {
    userStateKey: 'viewedVideoTourCabinet',
    contentfulId: '62p7LHhvIJFdo16MqQI09c',
  },
  {
    userStateKey: 'viewedVideoTourPolicy',
    contentfulId: '5axmkCabuqbrjTePM9l4E7',
  },
  {
    userStateKey: 'viewedVideoTourReportCards',
    contentfulId: '4fwsOdEkqlDOLo713XxZtk',
  },
  {
    userStateKey: 'viewedVideoTourStaffFolder',
    contentfulId: '7FYUH5DlgGmKRgkJQlZxeA',
  },
];

export default videoTours;
